import ShopifyMultipassLoginPage from './ShopifyMultipassLoginPage'

export default ShopifyMultipassLoginPage
// eslint-disable-next-line import/export
export * from './ShopifyMultipassLoginPage'
